import React from 'react';
import { Container, Grid, Typography } from '@material-ui/core';

import { useStyles } from './style';

const Footer = () => {
    const classes = useStyles();

    return (
        <Container maxWidth="md" component="footer" className={classes.footer}>
            <Grid container spacing={4} justify="space-evenly">
                <Grid item xs={6} md={6}>
                    <Typography variant="h6">{`Oscar Joel Lira Lira`}</Typography>
                    <Typography variant="body2">{`Telefono: 771 569 4852`}</Typography>
                    <Typography variant="body2">{`Correo: oscarlira78@hotmail.com`}</Typography>
                </Grid>
                <Grid item xs={6} md={6}>
                    <Typography variant="body2">{`Cto. San Francisco 330, Fracc. Rdas. San Francisco`}</Typography>
                    <Typography variant="body2">{`Mineral de la Reforma, Hidalgo`}</Typography>
                    <Typography variant="body2">{`C.P. 42185`}</Typography>
                </Grid>
            </Grid>
        </Container>
    );
}

export default Footer;
